import { render, staticRenderFns } from "./Nfis.vue?vue&type=template&id=4e052de8&scoped=true&"
import script from "./Nfis.vue?vue&type=script&lang=js&"
export * from "./Nfis.vue?vue&type=script&lang=js&"
import style0 from "./Nfis.vue?vue&type=style&index=0&id=4e052de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e052de8",
  null
  
)

export default component.exports